// Вокабуляр тренировки QA.
import { z } from 'zod';

// ─── Чему учит карточка ─────────────────────────────────────────────────────
// Метка ставится по настоящей причине отказа из истории и нужна, чтобы видеть
// перекос набора: тридцать карточек про куар-код и ни одной про «не скриншот»
// — это не тренировка, а один и тот же вопрос тридцать раз.
//
// 'ok' — кадр, который реально доехал до заказчика и был принят; правильный
// ответ по нему «принять». Остальные метки — классы отказа, ВИДИМОГО в самом
// кадре. Административных отказов (переполненная ячейка, кап мерчанта,
// каскад с печать-QA) здесь нет намеренно: кадр при них выглядит безупречно,
// и учить по нему браковать — значит ставить человеку неверный рефлекс.
export const QA_TRAINING_LESSON = [
  'ok',
  'not_screenshot',
  'code',
  'duplicate',
  'wrong_category',
  'scope',
  'batch_defect',
  'render',
  'other',
] as const;
export const QaTrainingVerdictLessonSchema = z.enum(QA_TRAINING_LESSON);
export type QaTrainingLesson = z.infer<typeof QaTrainingVerdictLessonSchema>;
